"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "MeetingWorkspaceSearchServiceQueryParams", {
    enumerable: true,
    get: function() {
        return MeetingWorkspaceSearchServiceQueryParams;
    }
});
const _zod = require("zod");
const _utilsisomorphic = require("@performyard/utils-isomorphic");
const _base = require("../../base");
const MeetingWorkspaceSearchServiceQueryParams = _base.BaseSearchServiceQueryParams.extend({
    service: _zod.z.literal("meeting_workspace"),
    name_re: _zod.z.string().optional(),
    participant_id_all: (0, _utilsisomorphic.transformStringToArray)(_utilsisomorphic.transformObjectId).optional(),
    created_by_id_eq: _utilsisomorphic.transformObjectId.optional(),
    created_by_id_ne: _utilsisomorphic.transformObjectId.optional(),
    previous_meeting_start_date_time_gte: _utilsisomorphic.transformDate.optional(),
    previous_meeting_start_date_time_lte: _utilsisomorphic.transformDate.optional(),
    upcoming_meeting_start_date_time_gte: _utilsisomorphic.transformDate.optional(),
    upcoming_meeting_start_date_time_lte: _utilsisomorphic.transformDate.optional(),
    status_eq: _zod.z.string().optional(),
    status_in: _zod.z.array(_zod.z.string()).optional()
});
